module.exports = __webpack_public_path__ + "static/header-large-c5ecc3b5f23890aa0d5782672309949e.jpg";